import { PaintedScene } from '../PaintedScene';

export const SEEDLING_CLEARING_PHASER_KEY = 'SeedlingClearingScene' as const;
export const SEEDLING_CLEARING_MANIFEST_KEY = 's-406-seedling-clearing' as const;

export class SeedlingClearingScene extends PaintedScene {
  constructor() {
    super(SEEDLING_CLEARING_PHASER_KEY, SEEDLING_CLEARING_MANIFEST_KEY);
  }
}
